(function () {
  const CAPTURE = {};

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const MAX_EMAIL_LENGTH = 254;
  const MAX_NAME_LENGTH = 128;

  const EMAIL_HINT = /e-?mail/i;
  const FIRST_NAME_HINT = /(first|given|fore)[-_ ]?name|^fname$/i;
  const LAST_NAME_HINT = /(last|family|sur)[-_ ]?name|^lname$/i;
  const PHONE_HINT = /phone|mobile|tel(ephone)?/i;

  const NEVER_READ = { password: true, hidden: true, file: true };

  const seen = {};
  const DEDUPE_STORAGE_KEY = "_mvt_ident";

  let started = false;
  let context = null;

  let ownerMemory = "";

  function attrOf(el, name) {
    try {
      return el.getAttribute(name) || "";
    } catch (e) {
      return "";
    }
  }

  function hintsFor(el) {
    return [
      el.name || "",
      el.id || "",
      attrOf(el, "autocomplete"),
      attrOf(el, "placeholder"),
      attrOf(el, "aria-label"),
      attrOf(el, "data-name"),
    ].join(" ");
  }

  function isExempt(el) {
    try {
      return !!(el.closest && el.closest("[data-mvt-ignore]"));
    } catch (e) {
      return false;
    }
  }

  function readableInput(el) {
    if (!el || el.tagName !== "INPUT") return false;
    const type = (el.type || "text").toLowerCase();
    if (NEVER_READ[type]) return false;
    return !isExempt(el);
  }

  function isEmailField(el) {
    if (!readableInput(el)) return false;
    const type = (el.type || "text").toLowerCase();
    return type === "email" || EMAIL_HINT.test(hintsFor(el));
  }

  function valueOf(el) {
    try {
      return String(el.value == null ? "" : el.value).trim();
    } catch (e) {
      return "";
    }
  }

  function looksLikeEmail(value) {
    return !!value && value.length <= MAX_EMAIL_LENGTH && EMAIL_RE.test(value);
  }

  function fingerprint(value) {
    let hash = 5381;
    for (let i = 0; i < value.length; i++) {
      hash = ((hash << 5) + hash + value.charCodeAt(i)) | 0;
    }
    return String(hash >>> 0);
  }

  function currentVisitorId() {
    const live = window.MVTContext && window.MVTContext.visitorId;
    if (live) return live;

    const Utils = window.MVTUtils;
    if (Utils && typeof Utils.getOrCreateVisitorId === "function") {
      try {
        return Utils.getOrCreateVisitorId(context && context.projectKey) || "";
      } catch (e) {
        return "";
      }
    }
    return "";
  }

  function dedupeKey(email) {
    return fingerprint(currentVisitorId() + "|" + email);
  }

  var OWNER_STORAGE_KEY = "_mvt_ident_owner";

  function ownerRecord() {
    try {
      return window.sessionStorage.getItem(OWNER_STORAGE_KEY) || "";
    } catch (e) {
      return ownerMemory;
    }
  }

  function rememberOwner(record) {
    ownerMemory = record;
    try {
      window.sessionStorage.setItem(OWNER_STORAGE_KEY, record);
    } catch (e) {}
  }

  function conflictsWithOwner(email) {
    const visitorFp = fingerprint(currentVisitorId());
    const emailFp = fingerprint(email);
    const record = ownerRecord();
    const parts = record.split(":");
    if (parts.length === 2 && parts[0] === visitorFp) {
      return parts[1] !== emailFp;
    }
    if (parts.length === 2 && parts[0] !== visitorFp) {
      return false;
    }
    return false;
  }

  function takeOwnership(email) {
    rememberOwner(fingerprint(currentVisitorId()) + ":" + fingerprint(email));
  }

  function alreadySent(key) {
    if (seen[key]) return true;
    try {
      const stored = window.sessionStorage.getItem(DEDUPE_STORAGE_KEY) || "";
      return stored.split(",").indexOf(key) !== -1;
    } catch (e) {
      return false;
    }
  }

  function rememberSent(key) {
    seen[key] = true;
    try {
      const stored = window.sessionStorage.getItem(DEDUPE_STORAGE_KEY) || "";
      const keys = stored ? stored.split(",") : [];
      if (keys.indexOf(key) === -1) keys.push(key);

      window.sessionStorage.setItem(DEDUPE_STORAGE_KEY, keys.slice(-10).join(","));
    } catch (e) {}
  }

  function fieldScope(el) {
    try {
      const form = el.form || (el.closest && el.closest("form"));
      if (form) return form;
      let node = el.parentElement;
      while (node && node !== document.body) {
        if (node.querySelectorAll("input").length > 1) return node;
        node = node.parentElement;
      }
    } catch (e) {}
    return null;
  }

  function detailsNear(el) {
    const details = { firstName: "", lastName: "", phone: "" };
    const form = fieldScope(el);
    if (!form || !form.querySelectorAll) return details;

    let fields;
    try {
      fields = form.querySelectorAll("input");
    } catch (e) {
      return details;
    }

    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      if (!readableInput(field)) continue;
      const value = valueOf(field);
      if (!value || value.length > MAX_NAME_LENGTH) continue;
      const hints = hintsFor(field);
      if (!details.firstName && FIRST_NAME_HINT.test(hints)) {
        details.firstName = value;
      } else if (!details.lastName && LAST_NAME_HINT.test(hints)) {
        details.lastName = value;
      } else if (
        !details.phone &&
        ((field.type || "").toLowerCase() === "tel" || PHONE_HINT.test(hints))
      ) {
        details.phone = value;
      }
    }
    return details;
  }

  function identify(email, el) {
    const key = dedupeKey(email);
    if (alreadySent(key)) return false;
    if (typeof window.mvt !== "function") return false;

    if (conflictsWithOwner(email)) return false;

    rememberSent(key);
    takeOwnership(email);

    const details = detailsNear(el);
    try {
      window.mvt("identify", {
        email: email,
        firstName: details.firstName,
        lastName: details.lastName,
        phone: details.phone,
        source: "auto_capture",

        projectId: (context && context.projectKey) || "",
        publicApiBase: (context && context.publicApiBase) || "",
      });
    } catch (e) {}
    return true;
  }

  function harvestField(el) {
    if (!isEmailField(el)) return false;
    const value = valueOf(el);
    if (!looksLikeEmail(value)) return false;
    return identify(value, el);
  }

  function harvestWithin(root) {
    if (!root || !root.querySelectorAll) return false;
    let fields;
    try {
      fields = root.querySelectorAll("input");
    } catch (e) {
      return false;
    }
    let fired = false;
    for (let i = 0; i < fields.length; i++) {
      if (harvestField(fields[i])) fired = true;
    }
    return fired;
  }

  function formOf(el) {
    try {
      return (el && el.form) || (el && el.closest && el.closest("form")) || null;
    } catch (e) {
      return null;
    }
  }

  function isAdvanceControl(el) {
    if (!el || !el.tagName) return false;
    const tag = el.tagName;
    if (tag === "BUTTON" || tag === "A") return true;
    if (tag !== "INPUT") return false;
    const type = (el.type || "").toLowerCase();
    return type === "submit" || type === "button" || type === "image";
  }

  CAPTURE.start = function (options) {
    if (started) return;
    if (window.__MVT_AUTO_IDENTIFY__ === false) return;
    started = true;
    context = options || {};

    const onFieldSettled = function (event) {
      try {
        harvestField(event.target);
      } catch (e) {}
    };
    document.addEventListener("change", onFieldSettled, true);
    document.addEventListener("focusout", onFieldSettled, true);

    document.addEventListener(
      "submit",
      function (event) {
        try {
          harvestWithin(event.target);
        } catch (e) {}
      },
      true,
    );

    document.addEventListener(
      "pointerdown",
      function (event) {
        try {
          const target = event.target;
          if (!isAdvanceControl(target)) return;
          const scope = formOf(target);
          if (scope) harvestWithin(scope);
          else harvestWithin(document);
        } catch (e) {}
      },
      true,
    );
  };

  CAPTURE.sweep = function () {
    try {
      return harvestWithin(document);
    } catch (e) {
      return false;
    }
  };

  CAPTURE._test = {
    isEmailField: isEmailField,
    looksLikeEmail: looksLikeEmail,
    detailsNear: detailsNear,
    fingerprint: fingerprint,
  };

  window.MVTIdentifyCapture = CAPTURE;
})();
